var render, staticRenderFns
import script from "./ProfileBlockingModal.vue?vue&type=script&lang=js"
export * from "./ProfileBlockingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5370fd90')) {
      api.createRecord('5370fd90', component.options)
    } else {
      api.reload('5370fd90', component.options)
    }
    
  }
}
component.options.__file = "src/components/sys/term/ProfileBlockingModal.vue"
export default component.exports